export default {
  getCarrierFees: (state) => state.carrierFees
}
